import React, { useState, useEffect } from "react";
import { useLocation, useHistory } from "react-router";
import Header from "../../components/Header";
import Firebase from "../../firebasehelper";
import ButtonSwitcher from "../../components/ButtonSwitcher";
import MembersWelcomeMessage from "./MemberWelcome";
import "./index.css";
import ReferralsWelcomeMessage from "./ReferralsWelcome";

const tabs = ["Members", "Referred prospect"];

const WelcomeMessage = () => {
  const location = useLocation();
  const history = useHistory();
  const [brand_data, setBrandData] = useState({});
  const [brand, setBrand] = useState(null);
  const [role, setRole] = useState(null);
  const [username, setUserName] = useState("");

  const [tab, setTab] = useState(tabs[0]);

  useEffect(() => {
    if (!location.state) {
      history.push("/");
    } else {
      const { brand, role, username } = location.state;
      setBrand(brand);
      setRole(role);
      setUserName(username);
      Firebase.getBrandDataByID(brand, (brand_data) => {
        if (brand_data) {
          setBrandData(brand_data);
        }
      });
    }
  }, [location]);

  const goBack = () => {
    history.goBack();
  };

  return (
    <div id="page-container">
      <Header
        username={username}
        role={role}
        onHome={goBack}
        logo={brand_data.logo}
        brand={brand}
        brandName={brand_data.name}
        is_property_brand={brand_data.is_property_brand || false}
      />
      <div className="switcher-container">
        <ButtonSwitcher
          buttonsGroup={tabs}
          currentTab={tab}
          onSwitch={(t) => setTab(t)}
          hex={brand_data.hex}
          white={brand_data.white}
        />
      </div>
      {tab === tabs[0] ? (
        <MembersWelcomeMessage />
      ) : (
        <ReferralsWelcomeMessage />
      )}
    </div>
  );
};
export default WelcomeMessage;



// WEBPACK FOOTER //
// ./src/screens/WelcomeMessage/index.js